<template>
  <div class="date-picker" :class="classList">
    <div class="date-picker__title">
      {{ translatedTitle }}
    </div>
    <date-picker
      v-if="rangeTimePicker"
      v-model:value="selectedRangeDate"
      :disabled="disabled"
      format="DD.MM.YYYY HH:mm:ss"
      :clearable="false"
      :disabled-date="disabledDates"
      :placeholder="placeholder"
      :range="range"
      type="datetime"
      :show-minute="true"
      :show-hour="true"
      :show-second="false"
      :show-time-panel="showTimePanel"
      :lang="dpLang"
    >
      <template v-slot:icon-calendar>
        <svg
          width="13"
          height="13"
          viewBox="0 0 13 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.3242 1.01562H10.1562V0.40625C10.1562 0.181898 9.97438 0 9.75 0C9.52562 0 9.34375 0.181898 9.34375 0.40625V1.01562H3.65625V0.40625C3.65625 0.181898 3.47438 0 3.25 0C3.02562 0 2.84375 0.181898 2.84375 0.40625V1.01562H1.67578C0.75174 1.01562 0 1.76737 0 2.69141V11.3242C0 12.2483 0.75174 13 1.67578 13H11.3242C12.2483 13 13 12.2483 13 11.3242V2.69141C13 1.76737 12.2483 1.01562 11.3242 1.01562ZM1.67578 1.82812H2.84375V2.23438C2.84375 2.45873 3.02562 2.64062 3.25 2.64062C3.47438 2.64062 3.65625 2.45873 3.65625 2.23438V1.82812H9.34375V2.23438C9.34375 2.45873 9.52562 2.64062 9.75 2.64062C9.97438 2.64062 10.1562 2.45873 10.1562 2.23438V1.82812H11.3242C11.8002 1.82812 12.1875 2.21538 12.1875 2.69141V3.65625H0.8125V2.69141C0.8125 2.21538 1.19976 1.82812 1.67578 1.82812ZM11.3242 12.1875H1.67578C1.19976 12.1875 0.8125 11.8002 0.8125 11.3242V4.46875H12.1875V11.3242C12.1875 11.8002 11.8002 12.1875 11.3242 12.1875Z"
            fill="black"
            fill-opacity="0.6"
          />
        </svg>
      </template>
      <template v-slot:footer>
        <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
          {{
            showTimePanel
              ? `${$t('routes-management-block.popup.date-picker.set-date')}`
              : `${$t('routes-management-block.popup.date-picker.set-time')}`
          }}
        </button>
      </template>
    </date-picker>
    <date-picker
      v-else-if="range"
      v-model:value="selectedRangeDate"
      :disabled="disabled"
      format="DD.MM.YYYY HH:ss:mm"
      :clearable="false"
      :disabled-date="disabledDates"
      :placeholder="placeholder"
      :range="range"
      :type="type"
      :lang="dpLang"
    >
      <template v-slot:icon-calendar>
        <svg
          width="13"
          height="13"
          viewBox="0 0 13 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.3242 1.01562H10.1562V0.40625C10.1562 0.181898 9.97438 0 9.75 0C9.52562 0 9.34375 0.181898 9.34375 0.40625V1.01562H3.65625V0.40625C3.65625 0.181898 3.47438 0 3.25 0C3.02562 0 2.84375 0.181898 2.84375 0.40625V1.01562H1.67578C0.75174 1.01562 0 1.76737 0 2.69141V11.3242C0 12.2483 0.75174 13 1.67578 13H11.3242C12.2483 13 13 12.2483 13 11.3242V2.69141C13 1.76737 12.2483 1.01562 11.3242 1.01562ZM1.67578 1.82812H2.84375V2.23438C2.84375 2.45873 3.02562 2.64062 3.25 2.64062C3.47438 2.64062 3.65625 2.45873 3.65625 2.23438V1.82812H9.34375V2.23438C9.34375 2.45873 9.52562 2.64062 9.75 2.64062C9.97438 2.64062 10.1562 2.45873 10.1562 2.23438V1.82812H11.3242C11.8002 1.82812 12.1875 2.21538 12.1875 2.69141V3.65625H0.8125V2.69141C0.8125 2.21538 1.19976 1.82812 1.67578 1.82812ZM11.3242 12.1875H1.67578C1.19976 12.1875 0.8125 11.8002 0.8125 11.3242V4.46875H12.1875V11.3242C12.1875 11.8002 11.8002 12.1875 11.3242 12.1875Z"
            fill="black"
            fill-opacity="0.6"
          />
        </svg>
      </template>
    </date-picker>
    <date-picker
      v-else
      v-model:value="selectedDate"
      :disabled="disabled"
      format="DD.MM.YYYY"
      :clearable="false"
      :disabled-date="disabledDates"
      :placeholder="translatedPlaceholder"
      :lang="dpLang"
    >
      <template v-slot:icon-calendar>
        <svg
          width="13"
          height="13"
          viewBox="0 0 13 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.3242 1.01562H10.1562V0.40625C10.1562 0.181898 9.97438 0 9.75 0C9.52562 0 9.34375 0.181898 9.34375 0.40625V1.01562H3.65625V0.40625C3.65625 0.181898 3.47438 0 3.25 0C3.02562 0 2.84375 0.181898 2.84375 0.40625V1.01562H1.67578C0.75174 1.01562 0 1.76737 0 2.69141V11.3242C0 12.2483 0.75174 13 1.67578 13H11.3242C12.2483 13 13 12.2483 13 11.3242V2.69141C13 1.76737 12.2483 1.01562 11.3242 1.01562ZM1.67578 1.82812H2.84375V2.23438C2.84375 2.45873 3.02562 2.64062 3.25 2.64062C3.47438 2.64062 3.65625 2.45873 3.65625 2.23438V1.82812H9.34375V2.23438C9.34375 2.45873 9.52562 2.64062 9.75 2.64062C9.97438 2.64062 10.1562 2.45873 10.1562 2.23438V1.82812H11.3242C11.8002 1.82812 12.1875 2.21538 12.1875 2.69141V3.65625H0.8125V2.69141C0.8125 2.21538 1.19976 1.82812 1.67578 1.82812ZM11.3242 12.1875H1.67578C1.19976 12.1875 0.8125 11.8002 0.8125 11.3242V4.46875H12.1875V11.3242C12.1875 11.8002 11.8002 12.1875 11.3242 12.1875Z"
            fill="black"
            fill-opacity="0.6"
          />
        </svg>
      </template>
    </date-picker>
  </div>
</template>

<script>
import DatePicker from 'vue-datepicker-next'
import 'vue-datepicker-next/index.css'
import uk from 'vue-datepicker-next/locale/uk.es'
import en from 'vue-datepicker-next/locale/en.es'

import { mapState } from 'vuex'

export default {
  name: 'CustomDatePicker',
  components: {
    DatePicker,
  },
  props: {
    rangeTimePicker: {
      type: Boolean,
      default: false,
    },
    range: {
      type: Boolean,
      default: false,
    },
    label: {
      type: [String, Object],
      default: 'Дата',
    },
    initialDate: {
      type: String,
      default: null,
    },
    value: {
      type: [Date, String, Array],
      default: null,
    },
    mode: {
      type: String,
      default: 'base',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledDateHandler: {
      type: Function,
      default: null,
    },
    config: {
      type: Object,
      default() {
        return {}
      },
    },
    shouldTranslateTitle: {
      type: Boolean,
      default: false,
    },
    localizedTitle: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: [String, Object],
      default: '',
    },
    type: {
      type: String,
      default: 'date',
    },
  },
  data() {
    return {
      showTimePanel: false,
      selectedDate: null,
      selectedRangeDate: [null, null],
    }
  },
  created() {
    if (this.range) {
      if (Array.isArray(this.value) && this.value.length >= 2) {
        const startDate = this.$moment.isDate(this.value[0])
          ? this.value[0]
          : null
        const endDate = this.$moment.isDate(this.value[1])
          ? this.value[1]
          : null
        this.selectedRangeDate = [startDate, endDate]
      } else {
        this.selectedRangeDate = [null, null]
      }
    } else {
      if (this.value) {
        this.selectedDate = this.$moment.isDate(this.value)
          ? this.value
          : this.$moment(this.value).toDate()
      }
    }
  },
  watch: {
    value() {
      if (this.range) {
        if (this.value.every((item) => item !== null)) {
        } else {
          this.selectedRangeDate = null
        }
      } else {
        this.selectedDate = this.$moment.isDate(this.value)
          ? this.value
          : this.$moment(this.value).toDate()
      }
    },

    selectedLocale: {
      handler(val) {
        this.locale = val
      },
      immediate: true,
      deep: true,
    },

    selectedAdminLocale: {
      handler(val) {
        this.locale = val
      },
      immediate: true,
      deep: true,
    },

    selectedRangeDate() {
      if (Array.isArray(this.selectedRangeDate)) {
        const startDate = this.selectedRangeDate[0]
        const endDate = this.selectedRangeDate[1]
        this.$emit('update:value', [startDate, endDate])
      } else {
        console.log('...')
      }
    },

    selectedDate() {
      this.$emit('update:value', this.selectedDate)
    },
  },
  computed: {
    ...mapState(['selectedLocale']),
    adminLocale() {
      let lang = this.$i18n?.locale ?? 'en'
      return lang === 'ua' ? 'uk' : lang
    },
		dpLang() {
			const s = (this.selectedLocale || this.$i18n?.locale || 'en')
			const key = s === 'ua' ? 'uk' : s
			return key === 'uk' ? uk : en
		},
    disabledDates() {
      return this.disabledDateHandler ?? this.handleDisabledDate
    },
    ...mapState(['selectedLocale']),
    ...mapState('localeModule', ['selectedAdminLocale']),
    classList() {
      let _classList = [`date-picker--${this.mode}`]

      if (this.config.floatingTitle) {
        _classList.push('date-picker--floating-title')
      }

      if (this.config.transparent) {
        _classList.push('date-picker--transparent')
      }

      return _classList
    },
    translatedTitle() {
      if (this.shouldTranslateTitle) {
        return this.$t(this.label)
      }

      if (this.localizedTitle && typeof this.label === 'object') {
        let localeKey =
          this.selectedLocale === 'ua' ? 'uk' : this.selectedLocale
        if (!localeKey) {
          localeKey = this.adminLocale
        }
        return this.label[localeKey] ?? this.label['en'] ?? ''
      }

      return this.label
    },
    translatedPlaceholder() {
      if (this.shouldTranslateTitle) {
        return this.$t(this.placeholder)
      }

      if (this.localizedTitle && typeof this.placeholder === 'object') {
        let localeKey =
          this.selectedLocale === 'ua' ? 'uk' : this.selectedLocale
        if (!localeKey) {
          localeKey = this.adminLocale
        }
        return this.placeholder[localeKey] ?? this.placeholder['en'] ?? ''
      }

      return this.placeholder
    },
    translatedHint() {
      if (this.shouldTranslateTitle) {
        return this.$t(this.hint)
      }

      if (this.localizedTitle) {
        return this.hint['uk'] ?? this.hint
      }

      return this.hint
    },
  },
  methods: {
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel
    },

    handleDisabledDate(val1, val2) {
      return this.$moment().diff(this.$moment(val1), 'days') < 0
    },
  },
  emits: ['update:value'],
}
</script>

<style lang="scss">
.date-picker {
  position: relative;
  &__title {
    font-weight: 300;
    font-size: 11px;
    line-height: 13px;
    color: #909cb0;
    padding-left: 10px;
    margin-bottom: 5px;
  }

  .mx-datepicker {
    width: 100%;
  }

  .mx-input {
    padding: 13px 58px 13px 21px;
    height: auto;
    border: 1px solid #f2f4f7;
    border-radius: 8px;
    box-shadow: unset;

    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #666d79;
  }

  &--big & {
    &__title {
      font-weight: 400;
      font-size: 12px;
      line-height: 15px;
      color: #465a8b;
      padding: 2px 16px;
      position: absolute;
      top: 0;
      left: 17px;

      transform: translateY(-50%);
      background-color: #fff;
      z-index: 2;
    }
  }

  &--big {
    .mx-input {
      width: 100%;
      border: 1px solid #e0e6f2;
      background-color: transparent;
      border-radius: 6px;
      padding: 24px 15px 24px 21px;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #585f6d;
    }
  }

  &--floating-title {
    position: relative;
  }

  &--floating-title & {
    &__title {
      font-weight: 300;
      font-size: 11px;
      line-height: 13px;
      color: #909cb0;

      position: absolute;
      bottom: calc(100% + 5px);
      left: 10px;
      margin-bottom: 0;
    }
  }

  &--transparent {
    .mx-input {
      background: transparent;
    }
  }
}
</style>
